var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-wrapper"},[_vm._v(_vm._s(_vm.sanitized)+_vm._s((_vm.sanitized || '').length >= 160 ? '...' : ''))])}
var staticRenderFns = []

export { render, staticRenderFns }